const getDefaultState = () => {
  return {
    imageCoverShow: true,
    videoCoverShow: false
  }
}

const state = getDefaultState()

const getters = {
  getImageCoverShow(state) {
    return state.imageCoverShow
  },
  getVideoCoverShow(state) {
    return state.videoCoverShow
  }
}

const mutations = {
  RESET_VIDEO_COVER: state => {
    Object.assign(state, getDefaultState())
  },
  SET_IMAGE_COVER_SHOW: (state, show) => {
    state.imageCoverShow = show
  },
  SET_VIDEO_COVER_SHOW: (state, show) => {
    state.videoCoverShow = show
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
